import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

function PageRedirect({ path }: { path: string }) {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.push(path);
    }
  }, [match]);

  return null;
}

export default PageRedirect;
